import { useEffect } from 'react'

import {
  callDataSelector,
  clientRoleSelector,
  useStore,
} from '@liveHelper/models/store'

import { useJoinChannel } from '@core/agoraRTC'
import { useAgoraRTCClientContext } from '@core/agoraRTC/contexts/AgoraRTCClientContext'
import { useWakeLock } from '@core/hooks/useWakeLock'

/** Joins the video call Agora Channel. */
export const useJoinVideoCallChannel = () => {
  const client = useAgoraRTCClientContext()
  const clientRole = useStore(clientRoleSelector)
  const callData = useStore(callDataSelector)

  useWakeLock(!!callData?.id)

  const { leave } = useJoinChannel({
    agoraClient: client,
    clientRole,
    channelName: callData?.channel ?? '',
    token: callData?.token ?? '',
    uid: callData?.uid,
  })

  // when the hook is unmounted, leave the channel
  useEffect(() => {
    return () => {
      leave?.()
    }
  }, [leave])
}
